import { Component } from '@angular/core';
import { DashboardWrapperComponent } from '../../components/dashboard-wrapper/dashboard-wrapper.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Case } from 'app/application/interfaces/case';
import { MatIconModule } from '@angular/material/icon';
import { ApplicationDetailsComponent } from './components/application-details/application-details.component';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from '../../dashboard.service';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { AllApplicationsRecentComponent } from './components/all-applications-recent/all-applications-recent.component';
import { AllApplicationsPastComponent } from './components/all-applications-past/all-applications-past.component';
import { AllApplicationsDraftComponent } from './components/all-applications-draft/all-applications-draft.component';
import { AllApplicationsPaginationComponent } from './components/all-applications-pagination/all-applications-pagination.component';
import { isEmpty } from 'app/shared/utils';
import { ApplicationService } from 'app/services/application.service';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from 'app/components/modal/modal.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Component({
    selector: 'app-applications',
    standalone: true,
    imports: [
        CommonModule,
        LoaderComponent,
        DashboardWrapperComponent,
        TranslateModule,
        AllApplicationsRecentComponent,
        AllApplicationsPastComponent,
        AllApplicationsDraftComponent,
        AllApplicationsPaginationComponent,
        MatIconModule,
    ],
    templateUrl: './applications.component.html',
    styleUrl: './applications.component.scss',
})
export class ApplicationsComponent {
    activeTab: string = 'business';
    activeTableTab: string = 'recent';
    visibleCardsCount = 8; // default desktop
    initialCardCount = 8; // to store initial value based on device
    visibleCountMobile: number = 3; // initial visible items

    // approvedApplications = [
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (P2P Start-Up)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '44 business day(s)',
    //         interest: '65.5% per annum',
    //         tenure: '77 Year(s)',
    //         status: 'Application Approved',
    //         prodImage: 'assets/images/icons/affin.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000002',
    //         title: 'Product 2',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application cannot be reached',
    //         prodImage: 'assets/images/icons/ambank.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (e.g. P2P Start-Up Financing Scheme)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application Approved',
    //         prodImage: 'assets/images/icons/ambank.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (e.g. P2P Start-Up Financing Scheme)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application Approved',
    //         prodImage: 'assets/images/icons/ambank.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (e.g. P2P Start-Up Financing Scheme)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application Approved',
    //         prodImage: 'assets/images/icons/ambank.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (e.g. P2P Start-Up Financing Scheme)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application Approved',
    //         prodImage: 'assets/images/icons/ambank.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (e.g. P2P Start-Up Financing Scheme)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application Approved',
    //         prodImage: 'assets/images/icons/ambank.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (e.g. P2P Start-Up Financing Scheme)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application Approved',
    //         prodImage: 'assets/images/icons/ambank.png',
    //     },
    //     {
    //         date: '2025-05-22 16:20:00',
    //         ref: 'PNM-0000000001',
    //         title: 'Product 1 (e.g. P2P Start-Up Financing Scheme)',
    //         financing: 'RM 500,000 - RM 1,000,000',
    //         processing: '4 business day(s)',
    //         interest: '6.5% per annum',
    //         tenure: '7 Year(s)',
    //         status: 'Application Approved',
    //     },
    // ];
    initialCases: Case[] = [];
    approvedApplications: Case[] = [];
    allApplications: Case[] = [];
    // pastApplications = [
    //     {
    //         applicationId: 'MBN-000800901',
    //         product: 'Affin Bank Bizdana Start-Up Financing',
    //         amount: 'RM50,000',
    //         tenure: '1 Year(s)',
    //         referralDate: '5 May 2025 14:27:45',
    //         status: 'Application Approved',
    //     },
    //     {
    //         applicationId: 'MBN-000800901',
    //         product: 'Affin Bank Bizdana Start-Up Financing',
    //         amount: 'RM50,000',
    //         tenure: '1 Year(s)',
    //         referralDate: '5 May 2025 14:27:45',
    //         status: 'Application Approved',
    //     },
    //     {
    //         applicationId: 'MBN-000800901',
    //         product: 'Affin Bank Bizdana Start-Up Financing',
    //         amount: 'RM50,000',
    //         tenure: '1 Year(s)',
    //         referralDate: '5 May 2025 14:27:45',
    //         status: 'Application Approved',
    //     },
    //     {
    //         applicationId: 'MBN-1232345678',
    //         product: 'May Bank',
    //         amount: 'RM1,000',
    //         tenure: '22 Year(s)',
    //         referralDate: '15 May 2025 14:27:45',
    //         status: 'Application cannot be reached',
    //     },
    // ];
    pastApplications = [];

    isPastAppLoading: boolean = false;
    isDraftAppLoading: boolean = false;

    dateAvailable: boolean;

    currentPage: number = 1;
    itemsPerPage: number = 5;
    totalPages: number = 0;
    pagesToShow: (number | string)[] = [];

    selectedLanguage: any;
    appSubmitted: any;
    oneYearMsg;
    twoYearMsg;
    threeYearMsg;
    fourYearMsg;
    showProductDetails = false;
    apiResponse: boolean = false;
    showMoreIcon = true;
    applicantInformation = true;
    businessInformation = false;
    financingDetails = false;
    warning = false;

    clickedOutside: boolean = false;

    businessTypeOptions = [
        {
            value: 'SP',
            label: 'COMMON.SOLE_PROPRIETORSHIP',
        },
        {
            value: 'PN',
            label: 'COMMON.PARTNERSHIP',
        },
        {
            value: 'LLP',
            label: 'COMMON.LIMITED_LIABILITY',
        },
        {
            value: 'SDNBHD',
            label: 'COMMON.SDNBHD',
        },
        {
            value: 'PROFBODIES',
            label: 'COMMON.PROFESSIONAL_SERVICE_PROVIDER',
        },
        {
            value: 'IND',
            label: 'COMMON.INDIVIDUAL',
        },
    ];
    businessIndustryOptions = [
        {
            value: '1',
            label: 'COMMON.ELECTRICITY_GAS_WATER',
        },
        {
            value: '2',
            label: 'COMMON.AGRICULTURE_FORESTRY_FISHING',
        },
        {
            value: '3',
            label: 'COMMON.MINING_QUARRYING',
        },
        {
            value: '4',
            label: 'COMMON.MANUFACTURING',
        },
        {
            value: '5',
            label: 'COMMON.TRANSPORT_STORAGE_COMMUNICATION',
        },
        {
            value: '6',
            label: 'COMMON.FINANCING_INSURANCE_REAL_ESTATE_BUSINESS_SERVICE',
        },
        {
            value: '7',
            label: 'COMMON.CONSTRUCTION',
        },
        {
            value: '8',
            label: 'COMMON.WHOLESALE_RETAIL_TRADE_RESTAURANTS_HOTELS',
        },
        {
            value: '9',
            label: 'COMMON.OTHER_SERVICES',
        },
        {
            value: '10',
            label: 'COMMON.TOURISM',
        },
    ];

    PurposeOfFinancingOptions = [
        {
            value: 'CF',
            label: 'COMMON.CONTRACT_FINANCING',
        },
        {
            value: 'IF',
            label: 'COMMON.INVOICE_FINANCING',
        },
        {
            value: 'RC',
            label: 'COMMON.REVOLVING_CREDIT',
        },
        {
            value: 'TF',
            label: 'COMMON.TERM_FINANCING',
        },
        {
            value: 'WC',
            label: 'COMMON.WORKING_CAPITAL',
        },
    ];
    statusOptions = [
        {
            value: 'Submitted',
            label: 'APPLICATION_RECENT.APPLICATION_SUBMITTED',
        },
        {
            value: 'Referred',
            label: 'APPLICATION_RECENT.APPLICATION_SUBMITTED',
        },
        {
            value: 'Reject',
            label: 'APPLICATION_RECENT.APPLICATION_REJECTED',
        },
        {
            value: 'Cancel',
            label: 'APPLICATION_RECENT.APPLICATION_CANCEL',
        },
        {
            value: 'Complete Disbursement',
            label: 'APPLICATION_RECENT.APPLICATION_DISBURSEMENT_COMPLETE',
        },
        {
            value: 'Disbursement',
            label: 'APPLICATION_RECENT.APPLICATION_DISBURSEMENT',
        },
        {
            value: 'Customer Acceptance',
            label: 'APPLICATION_RECENT.APPLICATION_CUSTOMER_ACCEPTANCE',
        },
        {
            value: 'SME Declined',
            label: 'APPLICATION_RECENT.APPLICATION_SME_DECLINED',
        },
        {
            value: 'Approval',
            label: 'APPLICATION_RECENT.APPLICATION_APPROVAL',
        },
        {
            value: 'Unmaterialized',
            label: 'APPLICATION_RECENT.APPLICATION_UNMATERIALISED',
        },
        {
            value: 'Uncontactable',
            label: 'APPLICATION_RECENT.APPLICATION_UNCONTACTABLE',
        },
        {
            value: 'Application Submission',
            label: 'APPLICATION_RECENT.APPLICATION_SUBMISSION',
        },
        {
            value: 'P2P Hosting',
            label: 'APPLICATION_RECENT.APPLICATION_P2P_HOSTING',
        },
        {
            value: 'Funded',
            label: 'APPLICATION_RECENT.APPLICATION_FUNDED',
        },
        {
            value: 'Unfunded',
            label: 'APPLICATION_RECENT.APPLICATION_UNFUNDED',
        },
        {
            value: 'Declined',
            label: 'APPLICATION_RECENT.PROCESSING',
        },
        {
            value: 'Successful',
            label: 'APPLICATION_RECENT.SUCCESSFUL',
        },
    ];
    isAuthenticated: boolean;
    isMobile = window.innerWidth < 768;
    appId: number | null = null;
    getUtmId: any;
    getUtmSource: any;
    caseId: any;

    constructor(
        private _dashboardService: DashboardService,
        private translate: TranslateService,
        private router: Router,
        public dialog: MatDialog,
        private _activeRoute: ActivatedRoute,
        private applicationService: ApplicationService,
        private toastr: ToastrService,
    ) {
        // this.selectedLanguage = localStorage.getItem('language');
        this._dashboardService.language$.subscribe((lang) => {
            this.selectedLanguage = lang;
        });
        this._activeRoute.queryParams?.subscribe((params) => {
            const { appId } = params;
            if (appId) this.appId = Number(appId);
        });
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        if (this.isAuthenticated == false) {
            this.router.navigate(['/login']);
        }
    }

    ngOnInit() {
        this.getUtmId = JSON.parse(sessionStorage.getItem('utm_id'));
        this.getUtmSource = JSON.parse(sessionStorage.getItem('utm_source'));

        const screenWidth = window.innerWidth;

        if (screenWidth >= 768 && screenWidth < 1188) {
            // updated to 1188 as ipad-air(should show 6 cards) is having 1180px width in landscape::KSK
            // Tablet
            this.visibleCardsCount = 6;
            this.initialCardCount = 6;
        } else {
            // Desktop
            this.visibleCardsCount = 8;
            this.initialCardCount = 8;
        }

        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 768; // updated to 1188 as ipad-air(should show 6 cards) is having 1180px width in landscape::KSK
            let width = window.innerWidth;
            if (width >= 768 && width < 1188) {
                // Tablet
                this.visibleCardsCount = 6;
                this.initialCardCount = 6;
            } else {
                // Desktop
                this.visibleCardsCount = 8;
                this.initialCardCount = 8;
            }
        });
        this.getTranslations();
        this.getApprovedApplications(this.activeTab);
    }

    getTranslations() {
        this.translate
            .get('APPLICATION_RECENT.APPLICATION_SUBMITTED')
            .subscribe((data: any) => {
                this.appSubmitted = data;
            });

        this.translate
            .get('COMMON.A_YEAR_LESS_THAN_TWO')
            .subscribe((data: any) => {
                this.oneYearMsg = data;
            });

        this.translate
            .get('COMMON.TWO_LESS_THAN_THREE')
            .subscribe((data: any) => {
                this.twoYearMsg = data;
            });

        this.translate
            .get('COMMON.THREE_LESS_THAN_FOUR')
            .subscribe((data: any) => {
                this.threeYearMsg = data;
            });

        this.translate.get('COMMON.FOUR_AND_ABOVE').subscribe((data: any) => {
            this.fourYearMsg = data;
        });
    }

    getProductByName(product: string) {
        if (product.includes('CEDAR')) {
            return 'Center for Enterpreneuer Developmen and Research';
        } else if (product.includes('MIA')) {
            return 'Malaysian Institute of Accountant';
        } else if (product.includes('INSKEN')) {
            return 'Institut Keusahawanan Negara';
        }
    }

    getProbabilityTrend(val: string): string {
        if (val == '1') {
            return this.oneYearMsg;
        } else if (val == '2') {
            return this.twoYearMsg;
        } else if (val == '3') {
            return this.threeYearMsg;
        } else if (val == '4') {
            return this.fourYearMsg;
        }
    }

    convertToTimeFormat(dateTimeString: string) {
        return dateTimeString.split(' ')[1];
    }

    onTabChange(tab: string) {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
            this.activeTableTab = this.getDefaultTableTabFor(tab);
            // Reset pagination count
            this.visibleCardsCount = this.initialCardCount;
            this.apiResponse = false;
            // Fetch new tab data
            this.getApprovedApplications(tab);
        }
    }

    onTableTabChange(tab: string) {
        this.activeTableTab = tab;
        this.currentPage = 1;
        this.updatePagination();
        if (tab === 'past') {
            this.isPastAppLoading = true;
            this.getPastApplications();
        }
    }

    private getDefaultTableTabFor(tab: string): string {
        return tab === 'business' ? 'recent' : 'recent';
    }

    getApprovedApplications(tab: string) {
        let categoryCode = '';
        switch (tab) {
            case 'business':
                categoryCode = 'CGC';
                break;
            case 'branch':
                categoryCode = 'BRP';
                break;
            case 'portfolio':
                categoryCode = 'PG';
                break;
        }
        this.getApprovedApplicationsByCategory(categoryCode);
    }

    getApprovedApplicationsByCategory(categoryCode: string) {
        this.initialCases = [];
        this.allApplications = [];
        this.approvedApplications = [];
        let source = categoryCode;
        this._dashboardService.getApplications(source).subscribe({
            next: (response) => {
                this.apiResponse = true;
                const extraValues = {
                    drop: false,
                    showmoreicon: true,
                    appInfo: true,
                    businessInfo: false,
                    financingInfo: false,
                };
                this.initialCases = response.map((caseData) => {
                    if (this.appId && caseData?.caseId === this.appId) {
                        this.viewAppDetails(caseData);
                    }
                    caseData.productValidation = JSON.parse(
                        caseData.prodValidation,
                    );
                    this.statusOptions.forEach((item) => {
                        if (caseData.cCaseStatus === item.value) {
                            caseData.cCaseStatus = item.label;
                        } else if (caseData.cCaseStatus == null) {
                            caseData.cCaseStatus = 'null';
                        }
                    });
                    return { ...caseData, ...extraValues };
                });
                this.allApplications = this.initialCases;
                this.approvedApplications = this.initialCases.filter(
                    (c) =>
                        c.cCaseStatus ===
                        'APPLICATION_RECENT.APPLICATION_CUSTOMER_ACCEPTANCE',
                );
                this.updatePagination();
            },
            error: (err) => {
                this.apiResponse = true;
            },
        });
    }

    getApplicationDetails(caseId) {
        this._dashboardService.getApplicationDetails(caseId).subscribe({
            next: (response) => {
                response.productValidation = JSON.parse(
                    response.prodValidation,
                );
                this.statusOptions.forEach((item) => {
                    if (response.cCaseStatus === item.value) {
                        response.cCaseStatus = item.label;
                    } else if (response.cCaseStatus == null) {
                        response.cCaseStatus = 'null';
                    }
                });
                // let documents = [
                //     // {
                //     //     caseId: -4016214,
                //     //     docsId: 7535,
                //     //     status: 'ACTIVE',
                //     //     originalfilename: 'testPdf.pdf',
                //     //     filesize: '13264',
                //     //     alias: 'CONSENT_DOC',
                //     // },
                //     {
                //         caseId: -4016214,
                //         docsId: 7536,
                //         status: 'ACTIVE',
                //         originalfilename: 'testPdf.pdf',
                //         filesize: '13264',
                //         alias: 'NRIC',
                //     },
                //     {
                //         caseId: -4016214,
                //         docsId: 7537,
                //         status: 'ACTIVE',
                //         originalfilename: 'testPdf.pdf',
                //         filesize: '13264',
                //         alias: 'CCRIS',
                //     },
                //     {
                //         caseId: -4016214,
                //         docsId: 7538,
                //         status: 'ACTIVE',
                //         originalfilename: 'testPdf.pdf',
                //         filesize: '13264',
                //         alias: 'CTOS',
                //     },
                //     {
                //         caseId: -4016214,
                //         docsId: 7539,
                //         status: 'ACTIVE',
                //         originalfilename: 'testPdf.pdf',
                //         filesize: '13264',
                //         alias: 'BANK_STATEMENT',
                //     },
                //     {
                //         caseId: -4016214,
                //         docsId: 7540,
                //         status: 'ACTIVE',
                //         originalfilename: 'testPdf.pdf',
                //         filesize: '13264',
                //         alias: 'SSM_DOC',
                //     },
                //     {
                //         caseId: -4016214,
                //         docsId: 7541,
                //         status: 'ACTIVE',
                //         originalfilename: 'testPdf.pdf',
                //         filesize: '13264',
                //         alias: 'PROOF_OF_ADDRESS',
                //     },
                // ];
                // response.documents = documents;
                response.selectedLanguage = this.selectedLanguage;
                response.activeTab = this.activeTab;
                let data = response;
                this.dialog.open(ApplicationDetailsComponent, {
                    width: '100%',
                    maxWidth: this.isMobile ? '355px' : '936px',
                    panelClass: 'app-details-modal-container',
                    disableClose: false,
                    data,
                });
            },
            error: (err) => {
                // this.apiResponse = true;
            },
        });
    }

    getPastApplications() {
        this._dashboardService.getOldCaseStatus().subscribe({
            next: (data: any) => {
                data?.caselist.map((val) => {
                    val.map((item) => {
                        let cCaseStatusValue: any;
                        if (isEmpty(item?.pcaseLoan?.cCaseStatus)) {
                            cCaseStatusValue = item?.pcaseLoan?.cCaseStatus;
                        } else if (
                            isEmpty(item?.pcaseLoan?.cCaseLatestDecision)
                        ) {
                            cCaseStatusValue =
                                item?.pcaseLoan?.cCaseLatestDecision;
                        } else if (isEmpty(item?.pcaseLoan?.cCaseAlType)) {
                            if (item?.pcaseLoan?.cCaseAlType == 'DRP_OUT') {
                                cCaseStatusValue = 'Drop Out';
                            } else {
                                cCaseStatusValue = item?.pcaseLoan?.cCaseAlType;
                            }
                        } else {
                            cCaseStatusValue = 'Unknown';
                        }

                        let createdDateTimeValue: any;
                        if (isEmpty(item?.pcaseLoan?.cCaseSubmitDate)) {
                            this.dateAvailable = true;
                            createdDateTimeValue =
                                item?.pcaseLoan?.cCaseSubmitDate;
                        } else if (isEmpty(item?.updatedDateTime)) {
                            this.dateAvailable = true;
                            createdDateTimeValue = item?.updatedDateTime;
                        } else {
                            this.dateAvailable = false;
                            createdDateTimeValue = 'Not Available';
                        }

                        let pastDraftsObject = {
                            cCaseAppNo: item?.pcaseLoan?.cCaseAppNo,
                            prodCat: item?.prodSelectionList?.prodCat,
                            createdDateTime: createdDateTimeValue,
                            cCaseBizName: item?.pcaseLoan?.cCaseBizName,
                            cCaseBizRegNo: item?.pcaseLoan?.cCaseBizRegNo,
                            productName: item?.prodSelectionList?.productName,
                            cCaseFinamt: item?.pcaseLoan?.cCaseFinamt,
                            cCaseApproveAmt: item?.pcaseLoan?.cCaseApproveAmt,
                            caseId: item?.caseId,
                            cCaseStatus: cCaseStatusValue,
                        };
                        this.pastApplications.push(pastDraftsObject);
                    });
                });
                this.isPastAppLoading = false;
                this.updatePagination();
            },
            error: (err) => {
                this.isPastAppLoading = false;
            },
        });
    }

    formatDate(inputTime: string) {
        let dateObj = new Date(inputTime);
        let month = dateObj.toLocaleString('en-us', { month: 'short' });
        let day = dateObj.getDate();
        let year = dateObj.getFullYear();
        let formattedDate = day + ' ' + month + ' ' + year;

        return formattedDate;
    }

    getBusinessConstitution(bizconst: string) {
        return this.businessTypeOptions.find((item) => item.value === bizconst)
            .label;
    }

    getBusinessSector(index: string) {
        return this.businessIndustryOptions.find((item) => item.value === index)
            .label;
    }

    getPurposeOfFinancing(bizPof: string) {
        return this.PurposeOfFinancingOptions.find(
            (item) => item.value === bizPof,
        ).label;
    }

    onShowMore() {
        this.visibleCardsCount += this.initialCardCount; // load the same number as initial
    }

    onShowMoreMobile() {
        this.visibleCountMobile += 3; // show next 3
    }

    // Slice data for current page
    get paginatedData() {
        const dataSource =
            this.activeTableTab === 'recent'
                ? this.allApplications
                : this.activeTableTab === 'past'
                  ? this.pastApplications
                  : [];

        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;

        return dataSource.slice(start, end);
    }

    // Update pagination on data change
    updatePagination() {
        const dataSource =
            this.activeTableTab === 'recent'
                ? this.allApplications
                : this.activeTableTab === 'past'
                  ? this.pastApplications
                  : [];

        this.totalPages = Math.ceil(dataSource.length / this.itemsPerPage);
        if (this.currentPage > this.totalPages) {
            this.currentPage = this.totalPages || 1;
        }
        this.updatePagesToShow();
    }

    // Build pages for desktop/tablet
    updatePagesToShow() {
        const total = this.totalPages;
        const current = this.currentPage;
        const pages: (number | string)[] = [];

        if (total <= 6) {
            for (let i = 1; i <= total; i++) pages.push(i);
        } else {
            pages.push(1, 2);
            if (current > 4) pages.push('...');
            if (current > 2 && current < total - 1) {
                pages.push(current - 1, current, current + 1);
            }
            if (current < total - 3) pages.push('...');
            pages.push(total);
        }

        this.pagesToShow = [...new Set(pages)];
    }

    // Navigation
    goToPreviousPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.updatePagesToShow();
        }
    }

    goToNextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.updatePagesToShow();
        }
    }

    goToPage(page: number | string) {
        if (page === '...') return;
        this.currentPage = page as number;
        this.updatePagesToShow();
    }

    // For mobile condensed pagination
    get totalPagesCount(): number {
        const dataSource =
            this.activeTableTab === 'recent'
                ? this.allApplications
                : this.activeTableTab === 'past'
                  ? this.pastApplications
                  : [];
        return Math.ceil(dataSource.length / this.itemsPerPage);
    }

    get mobilePagesToShow(): (number | string)[] {
        const pages: (number | string)[] = [];
        const total = this.totalPagesCount;
        const current = this.currentPage;

        if (total <= 5) {
            for (let i = 1; i <= total; i++) {
                pages.push(i);
            }
        } else {
            // Always show 1 & 2
            pages.push(1, 2);

            if (current > 4) {
                pages.push('...');
            }

            if (current > 2 && current < total - 1) {
                pages.push(current - 1, current, current + 1);
            }

            if (current < total - 3) {
                pages.push('...');
            }

            // Always show last page
            pages.push(total);
        }

        return [...new Set(pages)];
    }

    viewAppDetails(item) {
        this.getApplicationDetails(item.caseId);
    }

    // check for existing draft application
    onSubmitNewApp(draftStatus?) {
        let productData = {};

        if (draftStatus == 'startNewApp') {
            productData['deleteAndContinue'] = true;
        }

        if (this.getUtmSource && this.getUtmId == 'BRP') {
            productData['source'] = this.getUtmSource;
        } else if (this.getUtmId == 'CIDB') {
            productData['source'] = this.getUtmId;
        }

        if (this.isAuthenticated) {
            this.applicationService.createCaseProduct(productData).subscribe({
                next: (res: any) => {
                    let response = res;
                    if (response.drafts) {
                        let draftData = response.drafts;
                        if (
                            draftData.length > 0 &&
                            draftStatus !== 'startNewApp'
                        ) {
                            let selectedProductCode =
                                draftData[0].selectedProducts;
                            let selectedProductName = draftData[0].productName;
                            this.confirmDraftDialog(
                                draftData,
                                selectedProductCode,
                                'checkMatchingProducts',
                                selectedProductName,
                            );
                        } else if (
                            draftData.length > 0 &&
                            draftStatus == 'startNewApp'
                        ) {
                            draftData.forEach((element) => {
                                this.caseId = element.caseId;
                            });
                            this.router.navigate(['/corporate'], {
                                state: {
                                    setProductDetails: this.caseId,
                                    checkMatchingProduct: true,
                                },
                            });
                        }
                    } else {
                        response.forEach((element) => {
                            this.caseId = element.caseId;
                        });
                        this.router.navigate(['/corporate'], {
                            state: {
                                setProductDetails: this.caseId,
                                checkMatchingProduct: true,
                            },
                        });
                    }
                },
                error: (err) => {
                    this.toastr.error(err.error.message);
                },
            });
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: `/business-financing`,
                },
            });
        }
    }

    // to display modal when user click on start new application and have draft application
    confirmDraftDialog(
        draftData,
        selectedProductCode?,
        appProductFlow?,
        selectedProductName?,
        prodCode?,
    ) {
        let noOfDrafts = draftData.length;
        const dialogRef = this.dialog.open(ModalComponent, {
            data: {
                noOfDrafts,
            },
            scrollStrategy: new NoopScrollStrategy(),
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.data == 'resumeDraft') {
                draftData.forEach((element) => {
                    this.caseId = element.caseId;
                });
                let qType;
                draftData.map((ele) => {
                    qType = ele.qType;
                });
                this.resumeApp(
                    this.caseId,
                    qType,
                    selectedProductCode,
                    selectedProductName,
                );
            } else if (result.data == 'startNewApp') {
                if (appProductFlow == 'checkMatchingProducts') {
                    this.onSubmitNewApp('startNewApp');
                    // } else if (appProductFlow == 'selectProduct') {
                    //     this.onSelectProduct(prodCode, 'startNewApp');
                    // }
                }
            }
        });
    }

    // navigate based on resume application queue
    resumeApp(
        caseId: string,
        qType: string,
        selectedProduct?: string,
        selectedProductName?: string,
    ) {
        const matchedProductsFlowArr = [
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGC_USR_INFO',
            'LOAN_CGC_UPD_USR_INFO',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGC_BSNS_INFO',
            'LOAN_CGC_FI_OFFR_SCR',
            'LOAN_CGC_UPLD_DOC',
        ];
        const selectProductFlowArr = [
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGCP_UPD_USR_INFO',
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGCP_BSNS_INFO',
            'LOAN_CGCP_chk_elig',
            'LOAN_CGCP_UPLD_DOC',
        ];
        let appProductFlow;
        let isMatchedProductsFlow;
        if (matchedProductsFlowArr.includes(qType)) {
            appProductFlow = 'checkMatchingProducts';
            isMatchedProductsFlow = true;
        } else if (selectProductFlowArr.includes(qType)) {
            appProductFlow = 'selectProduct';
            isMatchedProductsFlow = false;
        }

        const navigationExtras = {
            state: {
                fromResume: true,
            },
        };
        if (appProductFlow == 'checkMatchingProducts') {
            navigationExtras.state['checkMatchingProduct'] = true;
        }

        if (this.getAppStepNo(qType) == 1) {
            navigationExtras.state['setProductDetails'] = caseId;
            navigationExtras.state['productName'] = selectedProductName;
            this.router.navigate(['/corporate'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 2) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 3) {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/business-info'], navigationExtras);
        } else if (this.getAppStepNo(qType) == 4) {
            //check-eligibility flow
            let productFlowData = {
                caseId: caseId,
                prodCode: selectedProduct,
                productFlow: isMatchedProductsFlow,
            };
            navigationExtras.state['productFlowData'] = productFlowData;
            this.router.navigate(['/business-info'], navigationExtras);
        } else {
            navigationExtras.state['caseId'] = caseId;
            this.router.navigate(['/corporate'], navigationExtras);
        }
    }

    // get application step number based on queue
    getAppStepNo(qType: string) {
        let step1Arr = [
            'LOAN_CGCP_ND_ANLS',
            'LOAN_CGC_ND_ANLS',
            'LOAN_CGCP_CHK_CNSN',
            'LOAN_CGC_CHK_CNSN',
            'LOAN_CGCP_USR_INFO',
            'LOAN_CGC_USR_INFO',
        ];
        let step2Arr = ['LOAN_CGCP_UPD_USR_INFO', 'LOAN_CGC_UPD_USR_INFO'];
        let step3Arr = ['LOAN_CGCP_BSNS_INFO', 'LOAN_CGC_BSNS_INFO'];
        let step4Arr = ['LOAN_CGCP_chk_elig', 'LOAN_CGC_FI_OFFR_SCR'];
        let step5Arr = ['LOAN_CGCP_UPLD_DOC', 'LOAN_CGC_UPLD_DOC'];
        if (step1Arr.includes(qType)) {
            return 1;
        } else if (step2Arr.includes(qType)) {
            return 2;
        } else if (step3Arr.includes(qType)) {
            return 3;
        } else if (step4Arr.includes(qType)) {
            return 4;
        } else if (step5Arr.includes(qType)) {
            return 4;
        }
    }
}
